'use client';

import { useStore } from 'zustand';

import { authStore } from '@/store/auth.store';

export interface UseOpenPaymentsAvailabilityResult {
  isAvailable: boolean;
  isResolved: boolean;
}

export function useOpenPaymentsAvailability(): UseOpenPaymentsAvailabilityResult {
  const authStatus = useStore(authStore, (state) => state.authStatus);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  const isResolved = authStatus !== 'loading';

  return { isResolved, isAvailable: isResolved && isLoggedIn };
}
